import { LookupAPNAddressResponse } from 'src/types/address';
import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';
import { DeckardError } from 'src/types/errors';
import { encodeApn } from './utils';

const SMARTY_STREETS_API_KEY = process.env.REACT_APP_SMARTY_API_KEY;
const SMARTY_STREETS_LICENSE = process.env.REACT_APP_SMARTY_LICENSE;

export const lookupAddress = async (
  searchTerm: string,
  selected = undefined
) => {
  const SMARTY_STREETS_BASE_URL = `https://us-autocomplete-pro.api.smartystreets.com/lookup`;
  const params = {
    key: SMARTY_STREETS_API_KEY,
    license: SMARTY_STREETS_LICENSE,
    selected: selected || '',
    search: searchTerm,
    source: 'all',
  };
  return await httpMethodFunctions.get(SMARTY_STREETS_BASE_URL, {
    params,
  });
};

export const lookupAPNAddress = async (
  apn: string,
  unitNumber = ''
): Promise<LookupAPNAddressResponse | undefined> => {
  if (!apn) return;
  const encodedApn = encodeApn(apn);
  const url = `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/apn/${encodedApn}`;
  try {
    const response = await httpMethodFunctions.get<LookupAPNAddressResponse>(
      url,
      {
        params: { ...(unitNumber ? { unitNumber } : {}) },
      }
    );
    const { data, status } = response;

    if (status === 200) {
      return data as LookupAPNAddressResponse;
    } else {
      console.error('Error loading APN address:', data);
      throw new Error('Failed on lookupAPNAddress endpoint');
    }
  } catch (error) {
    const { data } =
      (error as { response?: { data: DeckardError } })?.response ?? {};

    if (data?.Code === 'DkNotFound' && data?.Message) {
      throw new Error(data.Message);
    } else {
      throw new Error('Failed on lookupAPNAddress endpoint');
    }
  }
};

export const lookupAddressAPN = (address: string) => {
  if (!address) return;
  try {
    let result = httpMethodFunctions.get(
      `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/lookupAddress/${encodeURIComponent(address)}`
    );
    return result;
  } catch (err) {
    // Log err
  }
};
